import '@forgerock/login-widget/widget.css';
import './App.css';
import LoginWidget from './LoginWidget';

function App({contextPath, loginReferer, content, setup}) {
    return <LoginWidget contextPath={contextPath} loginReferer={loginReferer} content={content} setup={setup}/>;
}

export default App;
